import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { TabPanel, TabView } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BreadcrumbComponent from '../../../../components/Breadcrumb';

const ModuleView: React.FC = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const moduleData = location.state?.module;

    const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        return date.toLocaleString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hourCycle: "h23",
            timeZone: "Asia/Kuala_Lumpur",
        }).replace(", ", " ");
    };

    function handleBack(): void {
        navigate(`/admin/module`);
    }
    const toolbarTemplate = () => {
        return (
            <>
                <Button label="Back" icon="pi pi-times" style={{ marginRight: '.5em' }} onClick={() => handleBack()} />
            </>
        );
    };

    return (

        <div className="module-view">
            <div className="card-title">
                <h5>Module Details</h5>
                <BreadcrumbComponent />
            </div>

            <div className="card">
                <Accordion activeIndex={0}>
                    <AccordionTab header="Module Information">
                        <div className="p-fluid form-grid grid">
                            <div className="field col-12 md:col-6">
                                <label><strong>Module ID:</strong></label>
                                <p>{moduleData.moduleId || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Full Description:</strong></label>
                                <p>{moduleData.fullDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Short Description:</strong></label>
                                <p>{moduleData.shortDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Order Sequence:</strong></label>
                                <p>{moduleData.orderSeq || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Remark:</strong></label>
                                <p>{moduleData.remark || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Department Code:</strong></label>
                                <p>{moduleData.departmentCodeHasOne.fullDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Created By:</strong></label>
                                <p>
                                    {moduleData.insertByHasOne?.fullName || "N/A"} @{" "}
                                    {moduleData.insertDate ? formatDate(moduleData.insertDate) : "N/A"}
                                </p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Modified By:</strong></label>
                                <p>
                                    {moduleData.modifiedByHasOne?.fullName || "N/A"} @{" "}
                                    {moduleData.modifiedDate ? formatDate(moduleData.modifiedDate) : "N/A"}
                                </p>
                            </div>
                        </div>
                    </AccordionTab>
                </Accordion>
            </div>

            <Toolbar end={toolbarTemplate} />
        </div>

    );
};

export default ModuleView;